import { Inject } from '@odinjs/odin';

import { EQUALS, equalsValidator, PASSWORD_EQUALS, passwordEqualsValidator } from '@philips-emr/hpms-components';
import { ButtonAPI, FieldAPI, FormAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnMount, OnValidate } from '@philips-emr/tws-core/lib/client';
import { MountEvent, ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService, HttpService, ModalService } from '@philips-emr/tws-core/lib/services';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';

import { FragmentNames, ModalRedefinirSenhaAliases } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { ToastService } from '../../services';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.MODAL_REDEFINIR_SENHA })
export default class ModalRedefinirSenhaController extends BaseController {

  @Inject(ModalRedefinirSenhaAliases.FORM)
  private form: FormAPI;
  @Inject(ModalRedefinirSenhaAliases.BUTTON_CONFIRMAR)
  private buttonConfirmar: ButtonAPI;

  @OnValidate(ModalRedefinirSenhaAliases.FORM)
  onValidate = ({ valid }: ValidateEvent): void => this.buttonConfirmar.setEnabled(valid);

  @OnMount(ModalRedefinirSenhaAliases.FIELD_NOVA_SENHA)
  onMountFieldNovaSenha({ target }: MountEvent): void {
    const api = target as FieldAPI;
    api.addLocalValidator(PASSWORD_EQUALS, (value) => {
      const { senhaAtual } = this.form.getRecord();
      return passwordEqualsValidator(value as string, senhaAtual as string);
    });
  }

  @OnMount(ModalRedefinirSenhaAliases.FIELD_CONFIRMAR)
  onMountFieldConfirmar({ target }: MountEvent): void {
    const api = target as FieldAPI;
    api.addLocalValidator(EQUALS, (value) => {
      const { novaSenha } = this.form.getRecord();
      return equalsValidator(value as string, novaSenha as string);
    });
  }

  @OnClick(ModalRedefinirSenhaAliases.BUTTON_CONFIRMAR)
  onClick(): void {
    this.form.submit();
    if (this.form.isValid()) {

      this.setSubmitting(true);
      this.post()
        .then(response => {
          ToastService.open(response);
          ModalService.close(FragmentNames.MODAL_REDEFINIR_SENHA);
        })
        .catch(response => {
          ToastService.open(response);
          this.setSubmitting(false);
        });
    }
  }

  private post(): Promise<RequestResponse<{}>> {
    if (AuthenticationService.isAuthenticated()) {

      const { nrSeqBeneficiario } = this.context.getBulkData();
      return HttpService.post<{}>(Endpoints.POST.ALTERAR_SENHA, { nrSeqBeneficiario }, { body: this.form.getRecord() });
    }

    const { username: login } = this.context.getBulkData();
    return HttpService.post<{}>(Endpoints.POST.RENOVAR_SENHA, {}, { body: { ...this.form.getRecord(), login } });
  }

  private setSubmitting(value: boolean): void {
    this.form.setState({ submitting: value });
    this.buttonConfirmar.setState({ loading: value });
  }
}
